import { _c } from "../../../services/text-services";
// @ts-ignore
import { ProductsRowProps } from "../../../models/home-rows";
import ProductsRow from "./products-row";
import AppProductsRow from "./products-row.component";
import styles from "./products-row.component.module.scss";

function ProductsRowWrapper({
  products,
  title,
  sectionTitle,
  activeIndex,
  series,
  isRelatedFile,
  rowNumber,
  size,
  blur,
  itemsPerSlideInput,
  gaTitle = "",
}: ProductsRowProps) {
  return (
    <div className={_c(styles, "products-row-wrapper")}>
      <div className={"desktop"}>
        <ProductsRow
          products={products}
          title={title || ""}
          size={size}
          isRelatedFile={!!isRelatedFile}
          activeIndex={activeIndex}
          series={series}
          gaTitle={gaTitle}
        />
      </div>
      <div className={"mobile"}>
        <AppProductsRow
          productsArray={products}
          title={title || ""}
          isRelatedFile={!!isRelatedFile}
          gaTitle={gaTitle}
        />
      </div>
    </div>
  );
}

export default ProductsRowWrapper;
